import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"

import api from "assets/services/api";


function ModalAddProducts(props) {

    const { storageId } = useAuth();

    const [name, setName] = useState();
    const [full_name, setFull_name] = useState();
    const [code, setCode] = useState();
    const [box, setBox] = useState();
    const [weight, setWeight] = useState();
    const [standart_price, setStandart_price] = useState();
    const [two_percent, setTwo_percent] = useState();
    const [max_for_distributors, setMax_for_distributors] = useState();
    const [gtin, setGtin] = useState();
    const [dun, setDun] = useState();
    const [controlSnack, setControlSnack] = useState(false);
    const [br, setBR] = useState(false);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);


    async function handleAddProduct(e) {
        e.preventDefault();
        const response = await api.post('/product/admin/', {
            code,
            name,
            full_name,
            standart_price,
            id_admin: storageId,
            box,
            weight,
            max_for_distributors,
            two_percent,
            gtin,
            dun
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllProducts();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar produto
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddProduct}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridCode">
                            <Form.Label>Code</Form.Label>
                            <Form.Control onChange={event => setCode(event.target.value)} type="number" placeholder="Código do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control required onChange={event => setName(event.target.value)} type="text" placeholder="Nome do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridFullName">
                            <Form.Label>Nome completo</Form.Label>
                            <Form.Control onChange={event => setFull_name(event.target.value)} type="text" placeholder="Nome completo do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Quantidade por caixa</Form.Label>
                            <Form.Control onChange={event => setBox(event.target.value)} type="number" placeholder="Quantidade de produtos por caixa" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Peso por unidade</Form.Label>
                            <Form.Control onChange={event => setWeight(event.target.value)} type="decimal" placeholder="Peso por unidade" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridPrice">
                            <Form.Label>Preço</Form.Label>
                            <MaskReal value={standart_price} onChange={value => setStandart_price(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>1° porcentagem</Form.Label>
                            <MaskReal value={two_percent} onChange={value => setTwo_percent(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>3° Porcentagem</Form.Label>
                            <MaskReal value={max_for_distributors} onChange={value => setMax_for_distributors(value.replace(',', '.'))} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>GTIN</Form.Label>
                            <Form.Control onChange={event => setGtin(event.target.value)} type="text" placeholder="gtin" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>DUN</Form.Label>
                            <Form.Control onChange={event => setDun(event.target.value)} type="text" placeholder="dun" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Produto adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddProducts;